module.exports = "<div class=\"loading-dialog\">\r\n  <div class=\"dialog-header\">\r\n    <h3 class=\"dialog-title\">\r\n      <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\r\n      Loading\r\n    </h3>\r\n  </div>\r\n\r\n  <div class=\"dialog-content\">\r\n    <div class=\"loading-container\">\r\n      <p class=\"loading-message\">\r\n        {{message}}\r\n      </p>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/utilities/Dialog/dialog/loading-dialog/loading-dialog.component.html
// module id = ./src/app/utilities/Dialog/dialog/loading-dialog/loading-dialog.component.html
// module chunks = main